import _implicitStylesheets from "./input.css";
import _implicitScopedStylesheets from "./input.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="tag${0}"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<div class="showError${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<div class="reaminingChars${0}"${2}>${"t1"}</div>`;
const stc0 = {
  key: 0
};
const stc1 = {
  "wrapper": true
};
const stc2 = {
  classMap: {
    "slot": true,
    "left": true
  },
  key: 5
};
const stc3 = {
  attrs: {
    "name": "left"
  },
  key: 6
};
const stc4 = [];
const stc5 = {
  attrs: {
    "name": "left"
  },
  key: 7
};
const stc6 = {
  classMap: {
    "slot": true,
    "right": true
  },
  key: 10
};
const stc7 = {
  attrs: {
    "name": "right"
  },
  key: 11
};
const stc8 = {
  attrs: {
    "name": "right"
  },
  key: 12
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, gid: api_scoped_id, d: api_dynamic_text, t: api_text, sp: api_static_part, st: api_static_fragment, h: api_element, b: api_bind, s: api_slot, ti: api_tab_index} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8} = $ctx;
  return [api_element("div", stc0, [$cmp.label ? api_element("label", {
    className: api_normalize_class_name($cmp.labelCss),
    attrs: {
      "for": api_scoped_id($cmp.name)
    },
    key: 1
  }, [api_text(api_dynamic_text($cmp.label)), $cmp.showTag ? api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.tagLabel))]) : null]) : null, api_element("div", {
    classMap: stc1,
    key: 4,
    on: {
      "slotchange": _m0 || ($ctx._m0 = api_bind($cmp.handleSlotChange))
    }
  }, [$cmp.hasSlots.left ? api_element("div", stc2, [api_slot("left", stc3, stc4, $slotset)]) : null, !$cmp.hasSlots.left ? api_slot("left", stc5, stc4, $slotset) : null, $cmp.required ? api_element("input", {
    className: api_normalize_class_name($cmp.stateClassName),
    attrs: {
      "name": $cmp.name,
      "type": $cmp.type,
      "tabindex": api_tab_index($cmp.tabIndex),
      "min": $cmp.min,
      "max": $cmp.max,
      "maxlength": $cmp.maxLength,
      "placeholder": $cmp.placeholder,
      "aria-required": $cmp.required,
      "aria-label": $cmp.ariaLabel,
      "disabled": $cmp.disabled ? "" : null
    },
    props: {
      "value": $cmp.value
    },
    key: 8,
    on: {
      "change": _m1 || ($ctx._m1 = api_bind($cmp.handleChange)),
      "input": _m2 || ($ctx._m2 = api_bind($cmp.handleInput)),
      "focus": _m3 || ($ctx._m3 = api_bind($cmp.handleFocus)),
      "blur": _m4 || ($ctx._m4 = api_bind($cmp.handleBlur))
    }
  }) : null, !$cmp.required ? api_element("input", {
    className: api_normalize_class_name($cmp.stateClassName),
    attrs: {
      "name": $cmp.name,
      "type": $cmp.type,
      "tabindex": api_tab_index($cmp.tabIndex),
      "min": $cmp.min,
      "max": $cmp.max,
      "maxlength": $cmp.maxLength,
      "aria-label": $cmp.ariaLabel,
      "placeholder": $cmp.placeholder,
      "disabled": $cmp.disabled ? "" : null
    },
    props: {
      "value": $cmp.value
    },
    key: 9,
    on: {
      "change": _m5 || ($ctx._m5 = api_bind($cmp.handleChange)),
      "input": _m6 || ($ctx._m6 = api_bind($cmp.handleInput)),
      "focus": _m7 || ($ctx._m7 = api_bind($cmp.handleFocus)),
      "blur": _m8 || ($ctx._m8 = api_bind($cmp.handleBlur))
    }
  }) : null, $cmp.hasSlots.right ? api_element("div", stc6, [api_slot("right", stc7, stc4, $slotset)]) : null, !$cmp.hasSlots.right ? api_slot("right", stc8, stc4, $slotset) : null])]), $cmp._errorMessage ? api_static_fragment($fragment2, 14, [api_static_part(1, null, api_dynamic_text($cmp._errorMessage))]) : null, $cmp.showRemainingCharactersInfo ? api_static_fragment($fragment3, 16, [api_static_part(1, null, api_dynamic_text($cmp.charactersRemainingDescription))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["left", "right"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-49d6c3tnrur";
tmpl.legacyStylesheetToken = "undefined-_input";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
